import React, { useRef, useState } from 'react';
import { useClickAway } from 'react-use';
import { CampaignFiltersKeys } from 'modules/messagingInsights/types';
import { Truncate } from 'ui/utility/truncate';
import { BUTTON_VARIANTS } from 'ui/button';
import { Close16 } from 'ui/icons';
import { FilterOption } from './types';
import {
  StyledPaddedOptionMenu,
  StyledFilterRow,
  StyledSecondary,
  StyledClose,
  StyledFilterDropdown,
  StyledItem,
} from './Styled';

type FilterProps = {
  children: React.ReactNode;
  id: CampaignFiltersKeys;
  idx: number;
  value: any;
  contentObj: { id: CampaignFiltersKeys | null; replacementIdx: number };
  setContentObj: React.Dispatch<
    React.SetStateAction<{
      id: CampaignFiltersKeys | null;
      replacementIdx: number;
    }>
  >;
  onRemove: () => void;
  niceName: string;
  options: FilterOption[];
  selectedFilters: string[];
  onFilterClose: (id?: string | null) => void;
};

const parseArrayToString = (arr: string[]) => {
  if (arr.length <= 2) {
    return arr.join(' or ');
  }
  return `${arr.length} selected`;
};

const parseValue = (value: any) => {
  if (typeof value === 'undefined') {
    return null;
  }
  if (Array.isArray(value)) {
    return parseArrayToString(value);
  }
  return value.toString();
};

export const Filter = ({
  children,
  id,
  idx,
  value,
  contentObj,
  setContentObj,
  onRemove,
  niceName,
  options,
  selectedFilters,
  onFilterClose,
}: FilterProps) => {
  const valueDropdownRef = useRef(null);
  const selectFilterRef = useRef(null);

  const [showSelectFilter, setShowSelectFilter] = useState(false);

  useClickAway(valueDropdownRef, () => {
    onFilterClose(contentObj?.id);
    // @ts-ignore
    setContentObj({ id: '', replacementIdx: -1 });
  });

  useClickAway(selectFilterRef, () => {
    setShowSelectFilter(false);
  });
  const parsedVal = parseValue(value);
  return (
    <StyledFilterRow>
      <span ref={selectFilterRef}>
        <StyledSecondary
          onClick={() => {
            setShowSelectFilter(true);
          }}
        >
          <Truncate maxWidth={115}>{niceName || id}</Truncate>
        </StyledSecondary>
      </span>
      <span>is</span>
      <div>
        <StyledSecondary
          limitWidth
          isShowingDropdown={contentObj?.id === id}
          onClick={() => {
            setContentObj({ id, replacementIdx: -1 });
          }}
        >
          <span>{parsedVal || 'Select...'}</span>
        </StyledSecondary>
        {contentObj?.id === id && (
          <StyledFilterDropdown ref={valueDropdownRef}>{children}</StyledFilterDropdown>
        )}
      </div>
      <StyledClose
        variant={BUTTON_VARIANTS.GHOST}
        onClick={() => {
          if (showSelectFilter) {
            setShowSelectFilter(false);
          } else {
            onRemove();
          }
        }}
      >
        <Close16 />
      </StyledClose>

      {showSelectFilter && (
        <StyledPaddedOptionMenu ref={selectFilterRef}>
          {options.map((el: FilterOption) => (
            <StyledItem
              key={el.label}
              onClick={() => {
                setShowSelectFilter(false);
                if (selectedFilters.includes(el.id)) {
                  setContentObj({ id: el.id, replacementIdx: -1 });
                } else {
                  onRemove();
                  setContentObj({ id: el.id, replacementIdx: idx });
                }
              }}
            >
              {el.label}
            </StyledItem>
          ))}
        </StyledPaddedOptionMenu>
      )}
    </StyledFilterRow>
  );
};
